import React from "react";
import lady from "../images/lady.png";
const Sustainability = () => {
  return (
    <div className="sustainability brush-top brush-bottom">
      <div className="container">
        <div className="header">
          handpicked. carefully cleaned.
          <br />
          <span className="text-white">100% natural.</span>
          &nbsp;sustainable quality.
        </div>
        <div className="sub">
          <div className="image">
            <img src={lady} alt={"lady farmer"} />
          </div>
          <div className="desc text-white">
            We proudly source our hibiscus leaves from local farmers, with a special focus on empowering female growers. By partnering directly with
            these hardworking women, we ensure the finest quality ingredients while supporting sustainable livelihoods and strengthening our
            communities. Every sip of Rodo Tea celebrates their dedication and resilience.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sustainability;
